import { Operation } from '../../../__generated__/globalTypes'

import {
  ItemFragment,
  itemFragmentString,
} from '../../fragments/__generated__/ItemFragment'

import { sendDelayFragmentString } from '../../fragments/__generated__/SendDelayFragment'

import { giftVariationFragmentString } from '../../fragments/__generated__/GiftVariationFragment'

import { amountString } from '../../fragments/__generated__/Amount'

import { priceString } from '../../fragments/__generated__/Price'

import getItemRawString from '../GetItem.graphql'

const getItemString = [
  getItemRawString,
  itemFragmentString,
  sendDelayFragmentString,
  giftVariationFragmentString,
  amountString,
  priceString,
].join('\n\n')

export type GetItemData = {
  item: ItemFragment
}

export type GetItemVariables = {
  id: string
}

export type GetItem = Operation<GetItemData, GetItemVariables>

export const GetItem = ({ id }: GetItemVariables): GetItem => ({
  query: getItemString,
  variables: {
    id,
  },
})
